// Constants related to courses
export const COURSE_MODES = {
  VERIFIED: 'verified',
  PROFESSIONAL: 'professional',
  NO_ID_PROFESSIONAL: 'no-id-professional',
  AUDIT: 'audit',
  HONOR: 'honor',
  EXECUTIVE_EDUCATION: 'executive-education',
  PAID_EXECUTIVE_EDUCATION: 'paid-executive-education',
  UNPAID_EXECUTIVE_EDUCATION: 'unpaid-executive-education',
};

export const EXECUTIVE_EDUCATION_COURSE_MODES = [
  COURSE_MODES.EXECUTIVE_EDUCATION,
  COURSE_MODES.PAID_EXECUTIVE_EDUCATION,
  COURSE_MODES.UNPAID_EXECUTIVE_EDUCATION,
];
